import * as React from 'react';
import { Component } from 'react';
import { Button } from 'primereact/button';

import { ButtonsSetItems } from "./index";
import { ApiResponse, MessageObject } from "./interfaces";
import { tr } from "../../helpers/Utils";
import ApiClientModule from "../../../services/ApiClientModule";
import AdapterStrategy from "./AdapterStrategy";
import ColorButtonAdapter from "./AdapterStrategy/ColorButtonAdapter";
import ColorMessageAdapter from "./AdapterStrategy/ColorMessageAdapter";

interface ActionButtonProps extends ButtonsSetItems {
    loading: boolean;
    setLoading: (arg: boolean) => void;
    setMessage: (arg: MessageObject) => void;
    setStrategyAndExecute: (object: ApiResponse) => void;
}
interface ActionButtonState {}

const adapterStrategy = new AdapterStrategy();
class ActionButton extends Component<ActionButtonProps, ActionButtonState> {
    /**
     * Управляет состоянием. Изменяет глобальный loading для всех кнопок
     * Показывает message и также скроллит до нужного поля в форме
     */
    handleClick = () => {
        const {
            handler,
            error,
            setLoading,
            setMessage,
            setStrategyAndExecute,
        } = this.props;

        setLoading(true);
        const apiClientModule = new ApiClientModule();
        apiClientModule.get(
            handler,
            {},
            {
                success: (response): any => {
                    adapterStrategy.setStrategy(new ColorMessageAdapter());
                    setMessage(adapterStrategy.adapt(response.data.detail));
                    setLoading(false);
                    setStrategyAndExecute(response.data.detail);
                },
                error: (error) => {
                    adapterStrategy.setStrategy(new ColorMessageAdapter());
                    setMessage(adapterStrategy.adapt(error.response.data.detail));
                    setLoading(false);
                },
            }
        );
    }

    render() {
        const {
            label,
            color,
            loading
        } = this.props;

        adapterStrategy.setStrategy(new ColorButtonAdapter());
        return (
            // @ts-ignore
            <Button
                label={tr(label)}
                className={adapterStrategy.adapt({color})}
                onClick={this.handleClick}
                loading={loading}
                type="button"
            />
        );
    }
}

export default ActionButton;
